// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DeleteSpacePopup__popup-empty-groups-e13a90 {
  flex: none;
}

.DeleteSpacePopup__title-fbb176 {
  color: var(--base-80);
  font: var(--font-body-4);
  letter-spacing: var(--font-spacing-body-4);
  padding: 12px 24px 0;
}

.DeleteSpacePopup__divider-ee6fdf {
  background-color: var(--base-15);
  margin-top: 10px;
  margin-bottom: 10px;
  min-height: 12px;
}

.DeleteSpacePopup__header-df04ac {
  align-items: center;
  display: flex;
  justify-content: space-between;
  padding: 8px 24px;
}

.DeleteSpacePopup__header-title-a8884f {
  color: var(--base-80);
  font: var(--font-body-2);
  letter-spacing: var(--font-spacing-body-2);
}

.DeleteSpacePopup__deselect-button-d20d25 {
  cursor: pointer;
  color: var(--brand-primary-40);
  font: var(--font-body-2);
  letter-spacing: var(--font-spacing-body-2);
}

.DeleteSpacePopup__deselect-button-d20d25:hover,
.DeleteSpacePopup__deselect-button-d20d25:focus {
  color: var(--brand-primary-50);
}

.DeleteSpacePopup__deselect-button-d20d25:active {
  color: var(--brand-primary-60);
}

.DeleteSpacePopup__deselect-button-d20d25:disabled {
  color: var(--brand-primary-20);
  cursor: initial;
}

.DeleteSpacePopup__placeholder-f4b3a0 {
  overflow: hidden;
}

.DeleteSpacePopup__placeholder-item-a93177 {
  padding: 8px 24px;
}`, "",{"version":3,"sources":["webpack://./src/main/PopupManager/Popups/DeleteSpacePopup/DeleteSpacePopup.styles.m.css"],"names":[],"mappings":"AAAA;EACE,UAAA;AACF;;AAEA;EACE,qBAAA;EACA,wBAAA;EACA,0CAAA;EACA,oBAAA;AACF;;AAEA;EACE,gCAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;AACF;;AAEA;EACE,mBAAA;EACA,aAAA;EACA,8BAAA;EACA,iBAAA;AACF;;AAEA;EACE,qBAAA;EACA,wBAAA;EACA,0CAAA;AACF;;AAEA;EACE,eAAA;EACA,8BAAA;EACA,wBAAA;EACA,0CAAA;AACF;;AAEA;;EAEE,8BAAA;AACF;;AAEA;EACE,8BAAA;AACF;;AAEA;EACE,8BAAA;EACA,eAAA;AACF;;AAEA;EACE,gBAAA;AACF;;AAEA;EACE,iBAAA;AACF","sourcesContent":[".popup-empty-groups {\n  flex: none;\n}\n\n.title {\n  color: var(--base-80);\n  font: var(--font-body-4);\n  letter-spacing: var(--font-spacing-body-4);\n  padding: 12px 24px 0;\n}\n\n.divider {\n  background-color: var(--base-15);\n  margin-top: 10px;\n  margin-bottom: 10px;\n  min-height: 12px;\n}\n\n.header {\n  align-items: center;\n  display: flex;\n  justify-content: space-between;\n  padding: 8px 24px;\n}\n\n.header-title {\n  color: var(--base-80);\n  font: var(--font-body-2);\n  letter-spacing: var(--font-spacing-body-2);\n}\n\n.deselect-button {\n  cursor: pointer;\n  color: var(--brand-primary-40);\n  font: var(--font-body-2);\n  letter-spacing: var(--font-spacing-body-2);\n}\n\n.deselect-button:hover,\n.deselect-button:focus {\n  color: var(--brand-primary-50);\n}\n\n.deselect-button:active {\n  color: var(--brand-primary-60);\n}\n\n.deselect-button:disabled {\n  color: var(--brand-primary-20);\n  cursor: initial;\n}\n\n.placeholder {\n  overflow: hidden;\n}\n\n.placeholder-item {\n  padding: 8px 24px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"popup-empty-groups": `DeleteSpacePopup__popup-empty-groups-e13a90`,
	"popupEmptyGroups": `DeleteSpacePopup__popup-empty-groups-e13a90`,
	"title": `DeleteSpacePopup__title-fbb176`,
	"divider": `DeleteSpacePopup__divider-ee6fdf`,
	"header": `DeleteSpacePopup__header-df04ac`,
	"header-title": `DeleteSpacePopup__header-title-a8884f`,
	"headerTitle": `DeleteSpacePopup__header-title-a8884f`,
	"deselect-button": `DeleteSpacePopup__deselect-button-d20d25`,
	"deselectButton": `DeleteSpacePopup__deselect-button-d20d25`,
	"placeholder": `DeleteSpacePopup__placeholder-f4b3a0`,
	"placeholder-item": `DeleteSpacePopup__placeholder-item-a93177`,
	"placeholderItem": `DeleteSpacePopup__placeholder-item-a93177`
};
module.exports = ___CSS_LOADER_EXPORT___;
